export default __webpack_public_path__ + "bdd8a209fef7e3e9723d5db859fb6466.svg";